/**
 * Profile — Security card
 *
 * Presentational: change-your-own-password (with current-password
 * challenge) or admin reset-password. Controlled by ProfileInfoSection,
 * which owns the password state and submit handler.
 */

import { SettingsCard } from '../../common';
import { Box, Button, CircularProgress, Grid, TextField } from '../../ui';

interface ProfilePasswordCardProps {
  isOwnProfile: boolean;
  passwordData: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  };
  passwordErrors: any;
  passwordLoading: boolean;
  onPasswordChange: (field: string, value: string) => void;
  onSubmit: () => void;
}

export default function ProfilePasswordCard({
  isOwnProfile,
  passwordData,
  passwordErrors,
  passwordLoading,
  onPasswordChange,
  onSubmit,
}: ProfilePasswordCardProps) {
  return (
    <SettingsCard title={isOwnProfile ? 'Change password' : 'Reset password'}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {isOwnProfile && (
          <TextField
            label="Current password"
            type="password"
            fullWidth
            value={passwordData.currentPassword}
            onChange={(e) => onPasswordChange('currentPassword', e.target.value)}
            error={!!passwordErrors.currentPassword}
            helperText={passwordErrors.currentPassword}
          />
        )}
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="New password"
              type="password"
              fullWidth
              value={passwordData.newPassword}
              onChange={(e) => onPasswordChange('newPassword', e.target.value)}
              error={!!passwordErrors.newPassword}
              helperText={passwordErrors.newPassword}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="Confirm new password"
              type="password"
              fullWidth
              value={passwordData.confirmPassword}
              onChange={(e) => onPasswordChange('confirmPassword', e.target.value)}
              error={!!passwordErrors.confirmPassword}
              helperText={passwordErrors.confirmPassword}
            />
          </Grid>
        </Grid>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={passwordLoading}
            sx={{ px: 3 }}
          >
            {passwordLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : isOwnProfile ? (
              'Change password'
            ) : (
              'Reset password'
            )}
          </Button>
        </Box>
      </Box>
    </SettingsCard>
  );
}
